var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgVietnamese = function SvgVietnamese(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Z",
    fill: "#F42F4C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m12 14.333 3.3 2.334-1.233-3.8 3.266-2.467h-4.066L12 6.667 10.767 10.4h-4.1l3.266 2.467-1.233 3.8 3.3-2.334Z",
    fill: "#FFE62E"
  })));
};
export default SvgVietnamese;